export default "__VITE_ASSET__DNXy8a3q__"